// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { ResponsiveDropdown } from './responsive-dropdown';

/**
 * @class Jsw.SearchResponsiveDropdown
 * @extends Jsw.ResponsiveDropdown
 */
export const SearchResponsiveDropdown = Class.create(ResponsiveDropdown, {
    _initComponentElement($super) {
    },

    _addEvents($super) {
        this._addResponsiveEvents();
    },

    _addResponsiveEvents($super) {
        $super();
        $(this._applyTargetId).observe('click', function (event) {
            if ($$(`.${this._headerClass}`).first().hasClassName('r-show-top-search')) {
                event.stopPropagation();
            }
        }.bind(this));
    },

    _show($super, el) {
        $super(el);
        if ($$(`.${this._headerClass}`).first().hasClassName(this._responsiveHeaderClass)) {
            $(this._applyTargetId).addClassName('r-page-sidebar-search-active');
        }
    },
});



// WEBPACK FOOTER //
// ./jsw/search-responsive-dropdown.js